/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ResolveReportDto = {
  /**
   * 처리 상태 (resolved: 처리됨, rejected: 거절됨)
   */
  status: ResolveReportDto.status;
  /**
   * 처리 사유/메모
   */
  note?: string;
};
export namespace ResolveReportDto {
  /**
   * 처리 상태 (resolved: 처리됨, rejected: 거절됨)
   */
  export enum status {
    RESOLVED = "resolved",
    REJECTED = "rejected",
  }
}
